export default "__VITE_ASSET__CVjIYGU6__"